import { render, staticRenderFns } from "./StandardItemName.vue?vue&type=template&id=07d4c97b"
import script from "./StandardItemName.vue?vue&type=script&lang=js"
export * from "./StandardItemName.vue?vue&type=script&lang=js"
import style0 from "./StandardItemName.vue?vue&type=style&index=0&id=07d4c97b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports